export default __webpack_public_path__ + "static/media/game.5917c20d.png";